import * as Yup from 'yup'
import { Form, Col } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const Schema = Yup.object().shape({
    salaryRequest: Yup.number()
        .typeError("Ungültige Zahl")
        .positive()
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
});

export const SalaryAndWorkExperienceSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltswunsch EUR/Jahr*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gehaltswunsch EUR/Jahr eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="formWorkExperience">
                <Form.Label>Berufserfahrung</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="workExperience"
                    value={values.workExperience}
                    isValid={touched.workExperience && !errors.workExperience}
                    isInvalid={errors.workExperience}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.WorkExperience.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.workExperience}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};